import { GetStatementsApiParameter } from "@bToC/Services/StatementService";
import { getCustomById, getCustomDataView } from "@bToC/Store/Data/CustomDataState";
import { CustomState } from "@bToC/Store/Reducers";
import { createContext } from "react";

export const getStatementDataState = (state: CustomState, statementNumber: string | undefined) => {
    return getCustomById(state.statementReducer, statementNumber, id => state.statementReducer.idByStatmentNumber[id]);
};

export function getStatementDataView(state: CustomState, getStatementsParameter: GetStatementsApiParameter) {
    return getCustomDataView(state.statementReducer, getStatementsParameter);
}

export const StatementDataViewContext = createContext<ReturnType<typeof getStatementDataView>>({
    value: undefined,
    isLoading: false,
});

export const StatementDataStateContext = createContext<ReturnType<typeof getStatementDataState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
